<template>
  <div class="content Tabs">

    <b-tabs card>

      <b-tab :title="lang.tab_Categories" :title-link-class="textColors" :title-item-class="textColors" active>
        <b-container class="bv-example-row">
          <b-row>
            <b-col sm=3>

              <TreeComponent :reloadTree="reloadTree" :iscategory="editCategories" class="treecomponent"
                :lang="lang.Tree"></TreeComponent>
            </b-col>
            <b-col sm="3">
              <div>

                <p>{{lang.infotext_1}}:</p>
                
                <b-img id="image__category" class="category-image" src="" fluid alt="category image"></b-img>
                
              </div><br>

              <b-form-group label="">
                <b-form-radio-group id="radio-group-1" v-model="selected" :options="options" name="radio-options">
                </b-form-radio-group>
              </b-form-group>


              <div v-show="selected == 'update'">
                <p>{{lang.infotext_2}}.</p>

                <b-form inline>

                  <b-form-input id="input-category-name-update" class="input-category-name-update" :state="inputStatus"
                    v-model="categoryNameUpdate" :placeholder="lang.placeholder_Create"
                    aria-describedby="input-category-feedback" :disabled="disabled"></b-form-input>


                  <b-form-invalid-feedback id="input-category-feedback">
                    {{lang.validinfo_3}}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help">{{lang.infotext_2}}: {{selectedTreeItemObject.category}}
                  </b-form-text>
                  <!--<p  v-if="selectedTreeItemObject!==''" >{{`${lang.infotext_2} ${selectedTreeItemObject.name} : `}}</p>
                      <br>-->



                </b-form><br>

                <p>{{lang.infotext_4}}:</p>
                <b-form-file v-model="file" :state="null" :placeholder="lang.placeholder_file"
                  drop-placeholder="Drop file here..." class="import-file"
                  accept="image/jpeg, image/png, image/gif, image/svg" size="sm"></b-form-file>
                <br><br>
                <p>{{lang.infotext_6}}:</p>
                <b-form-input id="input-category-template-update" class="input-category-template-update"
                  v-model="partNumberTemplateUpdate" :placeholder="lang.placeholder_Template"></b-form-input>
                <br>
                <p>{{lang.infotext_13}}:</p>
                <b-form-group id="input-group-CISCompatible" :label="lang.label_CISCompatible" label-for="input-2">
                  <b-form-select v-model="cisCompatibleUpdate" size="sm" :options="optionsCisCompatible"  :disabled="getParent($store.getters.selectedTreeItemObject.parentId)">
                  </b-form-select>

                </b-form-group>
                <br>
                <b-button class="btn update-button" size="sm" :variant="variant" @click="updateCategory">
                  {{lang.button_Update}}
                </b-button>
              </div>




              <div v-show="selected == 'new'">
                <p>{{lang.infotext_5}}:</p>
                <b-form inline>

                  <b-form-input id="input-category-name" class="input-category-name" :state="inputStatus"
                    v-model="categoryName" :placeholder="lang.placeholder_Create"
                    aria-describedby="input-category-feedback"></b-form-input>


                  <b-form-invalid-feedback id="input-category-feedback">
                    {{lang.validinfo_1}}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help">{{lang.infotext_2}}: {{selectedTreeItemObject.category}}
                  </b-form-text>
                  <!--<p  v-if="selectedTreeItemObject!==''" >{{`${lang.infotext_2} ${selectedTreeItemObject.name} : `}}</p>
                      <br>-->



                </b-form><br>
                <p>{{lang.infotext_3}}:</p>
                <b-form-file v-model="file" :state="null" :placeholder="lang.placeholder_file"
                  drop-placeholder="Drop file here..." class="import-file"
                  accept="image/jpeg, image/png, image/gif, image/svg" size="sm"></b-form-file>
                <br><br>
                <p>{{lang.infotext_6}}:</p>
                <b-form-input id="input-category-template" class="input-category-template" v-model="partNumberTemplate"
                  :placeholder="lang.placeholder_Template"></b-form-input>
                <br>
                <p>{{lang.infotext_13}}:</p>
                <b-form-group id="input-group-CISCompatible" :label="lang.label_CISCompatible" label-for="input-2">
                  <b-form-select v-model="cisCompatible" size="sm" :options="optionsCisCompatible"></b-form-select>

                </b-form-group>
                <br>
                <b-button class="btn create-button" size="sm" :variant="variant" @click="createCategory">
                  {{lang.button_Create}}
                </b-button>
              </div>
              <hr>
              <p>{{lang.infotext_7}}</p>
              <p class="info-template"># - {{lang.infotext_8}}<br>
                {{lang.infotext_9}}<br>
                ### - {{lang.infotext_10}}<br><br>
                $ - {{lang.infotext_11}}<br>
                {{lang.infotext_9}}<br>
                $$$ - {{lang.infotext_12}}</p>




            </b-col>





          </b-row>


        </b-container>
      </b-tab>

    </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import TreeComponent from "@/components/shared/TreeComponent";


//import FormTableComponent from '@/components/shared/FormTableComponent'

export default {
  name: "Content",
  components: {
     TreeComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      selected: 'update',
      options: [
        { text: 'Update category', value: 'update' },
        { text: 'New category', value: 'new' },
        
      ],
      optionsCisCompatible: [
        { text: 'Orcad CIS compatible', value: true },
        { text: 'Generic', value: false },
      ],
      cisCompatible: true,
      file: null,
      categoriesData: {},
      categoryName:"",
      categoryNameUpdate: "",
      partNumberTemplate: "",
      partNumberTemplateUpdate: this.partNumberTemplateTree,
      cisCompatibleUpdate: false,
      disabled: false,
      inputStatus: null,

      reloadTree: false,
      editCategories: true,
      objectData:{},
      
      
      depth: null
      
    }
  },
  computed: {
    ...mapGetters({

      formDetailsData: 'formDetailsData',
      elementCategory: 'elementCategory',
      //projectCategoriesData: 'projectCategoriesData',
      selectedTreeItemObject:'selectedTreeItemObject',
    }),
    categoryId(){
      return this.$store.getters.selectedTreeItemObject.categoryId
    },
    image(){
      return this.$store.getters.selectedTreeItemObject.image;
    },
    categoryNameUpdateTree(){
      return this.$store.getters.selectedTreeItemObject.name;
    },
    partNumberTemplateTree(){
      return this.$store.getters.selectedTreeItemObject.partNumberTemplate;
    },
    cisCompatibleParam(){
      return this.$store.getters.selectedTreeItemObject.cisCompatible;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    
  },
  created () {
    this.categoryNameUpdate = this.$store.getters.selectedTreeItemObject.name;
    this.cisCompatibleUpdate = this.$store.getters.selectedTreeItemObject.cisCompatible;
    this.partNumberTemplateUpdate = this.$store.getters.selectedTreeItemObject.partNumberTemplate;
    this.depth = this.$store.getters.selectedTreeItemObject.depth;
    this.displayImageCategory();

  },

  updated() {
        
  },
  watch: {
    categoryId: function() {
      this.categoryNameUpdate = this.$store.getters.selectedTreeItemObject.name;
      this.cisCompatibleUpdate = this.$store.getters.selectedTreeItemObject.cisCompatible;
      this.partNumberTemplateUpdate = this.$store.getters.selectedTreeItemObject.partNumberTemplate;
      this.depth = this.$store.getters.selectedTreeItemObject.depth;
      this.displayImageCategory();
      
    },
    projectCategoriesData: function(newVal) {
     this.categoriesData = JSON.parse(newVal.data);


    },
    categoryName: function(newVal){
      if (newVal == ""){
        this.inputStatus = null;
      }else{
        this.inputStatus = true;
      }

      
    },
    categoryNameUpdateTree: function(newVal){
      if (newVal == ""){
        this.inputStatus = null;
      }else{
        this.inputStatus = true;
      }
      if(newVal == "All components"){
        this.disabled = true;
      }else{
        this.disabled = false;
      }
      
      this.categoryNameUpdate = newVal;
    },
    partNumberTemplateTree: function(newVal){
      
      
      this.partNumberTemplateUpdate = newVal;
    },
    
  },
  methods:{
    
    displayImageCategory(image = this.image){
    

      if (image != undefined){
        let vue = this;

        const obj = {
          fileName: image
        }
        

        
        this.$store.dispatch("getImage", obj)
        .then((result) => {
          console.log(result)
          
            
            vue.$nextTick(function () {

              let img = document.getElementById("image__category");
              
              img.src = "";
              img.src = URL.createObjectURL(result);
              

              
            })
            
            
        
        
        })


      }
      

    },
    createCategory(){
      
      if (this.categoryName != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }
        let obj = {
          parentId: this.selectedTreeItemObject.categoryId,
          fullPath: this.selectedTreeItemObject.category + "\\" + this.categoryName,
          //objAlertSuccess: this.objAlertSuccess,
          //objAlertError: this.objAlertError,
          file: file,
          template: this.partNumberTemplate,
          cisCompatible: this.cisCompatible
        }
        
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createCategory", obj)
           .then((result)=>{
              console.log(result.data)
              

             if (result.status == "OK") {
              if (result.data != null) {


                vue.categoryName = "";
                vue.inputStatus = null;


                vue.reloadTree = !vue.reloadTree;

                const obj = {
                  text: vue.lang.alert_success_create_category,
                  time: 10,
                  type: "success"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                const obj = {
                  text: vue.lang.alert_error_create_category + ": " + result.message,
                  time: 15,
                  type: "success"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              const obj = {
                text: vue.lang.alert_error_create_category + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);
            }
        })


      }else{

      }

    },
    
    updateCategory(){
      if (this.categoryNameUpdate != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }

        let path = this.selectedTreeItemObject.category;
        let temp = path.split("\\")
        

        let lei = temp.length;
        temp[lei - 1] = this.categoryNameUpdate
        

        let newPath = "";
        for(let i = 0; i < lei; i++ ){
          newPath += temp[i];
          if (i < lei - 1){
            newPath += "\\";
          }
        }
        

        let obj = {
          categoryId: this.selectedTreeItemObject.categoryId,
          fullPath: newPath,
          //objAlertSuccess: this.objAlertSuccessUpdate,
          //objAlertError: this.objAlertErrorUpdate,
          file: file,
          template: this.partNumberTemplateUpdate,
          cisCompatible: this.cisCompatibleUpdate
        }
        
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateCategory", obj)
          .then((result)=>{
            console.log(result.data)
            if (result.status == "OK") {
              if (result.data != null) {


                vue.reloadTree = !vue.reloadTree;

                vue.displayImageCategory(result.data.fileId);

                const obj = {
                  text: vue.lang.alert_success_update_category,
                  time: 10,
                  type: "success"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                const obj = {
                  text: vue.lang.alert_error_update_category + ": " + result.message,
                  time: 15,
                  type: "success"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              const obj = {
                text: vue.lang.alert_error_update_category + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);
            }
             
        })


      }else{
        
      }
    },
    getParent(id) {
      
      const dataTree = this.$store.getters.dataTree;
      
      if (dataTree.categoryId == id && dataTree.cisCompatible == true) {
        
        return true;
      }

      
      if (dataTree.children != undefined) {
        if (dataTree.children.length > 0) {
          
          if (this.categoriesChildren(dataTree.children, id) == true) {

            return true;
          }
        }
      }

      return false;
    },
    categoriesChildren: function (children, id) {
      
      
      for (var i = 0, lei = children.length; i < lei; i++) {

        if (children[i].categoryId == id && children[i].cisCompatible == true) {
       
          return true;
        }

        if (children[i].children.length > 0) {
          if (this.categoriesChildren(children[i].children, id) == true) {
            return true;
          };
        }
      }
      
      return false;
    },

  },
  
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .content .btn{
    margin-left: 5px;

  }
  .content .input-category-name{
     width: 100%;
  }
  .content .input-category-name-update{
     width: 100%;
  }
  .img-fluid {
    max-width: 100px;
    
  }
  .category-image{
    max-width: 100px;
    width: 100px;
  } 
   
  

  .info-template{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/Categories/Middle/Content/Content.vue